var render, staticRenderFns
import script from "./SharedMemberContactForm.vue?vue&type=script&lang=js&"
export * from "./SharedMemberContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59197c96')) {
      api.createRecord('59197c96', component.options)
    } else {
      api.reload('59197c96', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/src/components/shared/SharedMemberContactForm.vue"
export default component.exports